import PhotoContainerWrapper from '../src/PhotoContainerWrapper';
export default PhotoContainerWrapper;
